/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The method at which we process time logs for time quests
 * @export
 */
export const OWRewardMode = {
    ALLTIME: 'ALLTIME'
} as const;
export type OWRewardMode = typeof OWRewardMode[keyof typeof OWRewardMode];


export function instanceOfOWRewardMode(value: any): boolean {
    for (const key in OWRewardMode) {
        if (Object.prototype.hasOwnProperty.call(OWRewardMode, key)) {
            if (OWRewardMode[key as keyof typeof OWRewardMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OWRewardModeFromJSON(json: any): OWRewardMode {
    return OWRewardModeFromJSONTyped(json, false);
}

export function OWRewardModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWRewardMode {
    return json as OWRewardMode;
}

export function OWRewardModeToJSON(value?: OWRewardMode | null): any {
    return value as any;
}

export function OWRewardModeToJSONTyped(value: any, ignoreDiscriminator: boolean): OWRewardMode {
    return value as OWRewardMode;
}

